// Multi-currency helpers for the invoice pages. Exchange rate = dinar for 1 dollar.
// The server calculates the first price of a row (see AddInvoice / PurchasesInvoice `search_product`),
// these helpers only keep the "other currency" column in sync when the user edits a price by hand.

export const PRICE_MODE_FIXED    = 'fixed';
export const PRICE_MODE_EXCHANGE = 'exchange';

export function normalizeRate(rate, fallback = 0) {
   const value = parseFloat(rate);
   return Number.isFinite(value) && value > 0 ? value : fallback;
}

// dollar invoice => approximate dinar price, dinar invoice => dollar price
export function altPrice(price, currency, rate) {
   const value = parseFloat(price);
   const r     = normalizeRate(rate);

   if (!Number.isFinite(value) || r === 0) return 0;

   if (currency == 'dollar') return Math.round(value * r);

   return Math.round((value / r) * 100) / 100;
}

// currency the alternate column is shown in
export function altCurrency(currency) {
   return currency == 'dollar' ? 'dinar' : 'dollar';
}

// equivalent of a whole amount (invoice total) in the other currency, same rounding rules as `altPrice`
export const convertAmount = altPrice;
